export default __webpack_public_path__ + "static/Entenda0126-59dde5aa58c9aebecb1e298d89e8d9ed.jpg";